import GradientContainer from "@app/components/gradient/gradient-container"
import Image from "next/image"

const DesktopHeroBanner = () => {
  return (
    <div>
      <div className="flex justify-center items-center">
        <Image
          src="/images/industries/industries-hero.png"
          alt="industries-hero-banner"
          width={2560}
          height={883}
          layout="intrinsic"
        />
        <div className="absolute rounded-2xl bg-black bg-opacity-50 p-8 xl:p-10 w-[85%] flex items-center justify-center">
          <div className="flex flex-col space-y-6 justify-center items-center text-center">
            <div className="flex flex-row space-x-4 justify-center">
              <GradientContainer overrideClassName="rounded-xl text-light px-2 py-px">
                Expertise
              </GradientContainer>
              <GradientContainer overrideClassName="rounded-xl text-light px-2 py-px">
                Reliability
              </GradientContainer>
              <GradientContainer overrideClassName="rounded-xl text-light px-2 py-px">
                Innovation
              </GradientContainer>
            </div>
            <h1 className="h1 text-light">
              Industries
            </h1>
            <div className="text-body-xl text-light flex flex-col space-y-8">
              <div>
                <h6>
                  We represent a diverse client base, managing all waste and recycling categories.
                </h6>
                <h6>
                  Each industry represents its own unique facility, waste, and recycling requirements.
                </h6>
              </div>
              <h6>
                SimpleWaste provides the expertise, innovation, and reliability to facilitate every project.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopHeroBanner;
